import { ALERT_TYPE } from './../../utils/constants';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-notification-bar',
  templateUrl: './notification-bar.component.html'
})
export class NotificationBarComponent implements OnInit, OnChanges {

  @Output() notificationClose = new EventEmitter<void>();
  @Output() openExternalLink = new EventEmitter<void>();
  @Input() labelExternalLink: string;
  @Input() type: ALERT_TYPE;
  @Input() message = 'Teste';
  @Input() showBtnClose = true;
  notificationIcon = '';
  notificationStyle = '';

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes.type && changes.type.currentValue !== this.type) {
        this.type = changes.type.currentValue;
      }
      if (changes.message && changes.message.currentValue) {
        this.message = changes.message.currentValue;
      }
      if (changes.showBtnClose && changes.showBtnClose.currentValue !== this.showBtnClose) {
        this.showBtnClose = changes.showBtnClose.currentValue;
      }
      this.setNotificationProperties();
    }
  }

  ngOnInit() {
    this.setNotificationProperties();
  }

  handleCloseAction() {
    this.notificationClose.emit();
  }

  handleOpenExternalLink() {
    this.openExternalLink.emit();
  }

  setNotificationProperties() {
    switch (this.type) {
      case ALERT_TYPE.success:
        this.notificationIcon = 'success';
        this.notificationStyle = 'success';
        break;
      case ALERT_TYPE.info:
        this.notificationIcon = 'info';
        this.notificationStyle = 'info';
        break;
      case ALERT_TYPE.warn:
        this.notificationIcon = 'warning';
        this.notificationStyle = 'warn';
        break;
      case ALERT_TYPE.error:
        this.notificationIcon = 'error';
        this.notificationStyle = 'error';
        break;
      default:
        this.notificationIcon = 'info';
        this.notificationStyle = 'dark';
    }
  }

}
